import React from 'react';
import { Row, Col, Alert } from 'antd';
import { TextTitle, TextCustom } from '../../../components/text';
import { StyledContainerBlock } from '../../../components/container/styled';
import { convertStrToFormat } from '../../../functions';
import { GUTTER_LAYOUT, BREAKE_POINT, MARGINTOP20 } from '../../../resources';

export const ConfirmInfo = ({ data }) => {
  const { detail, booking, estimation } = data;

  return (
    <div style={{ ...MARGINTOP20 }}>
      <Row gutter={GUTTER_LAYOUT?.MAIN_CONTENT}>
        <Col {...BREAKE_POINT?.MAIN_CONTENT}>
          <StyledContainerBlock style={{ padding: '20px' }}>
            <TextTitle text={'รายละเอียดการรับซื้อ'} bold />
            {detail.map((el, i) => {
              return (
                <div className="space-container" key={`detail_${i}`}>
                  <span className="text-title">{el.title}</span>
                  <span className="text-detail">{el.description}</span>
                </div>
              );
            })}
            <div className="space-container">
              <span className="text-title">ราคาประเมิน</span>
              <span className="text-detail">
                {convertStrToFormat(estimation?.estimateprice, 'money')}
                <span style={{ fontSize: '20px' }}> บาท</span>
              </span>
            </div>
            <div className="space-container">
              <span className="text-title">ราคาโปรโมชั่น</span>
              <span className="text-detail">
                {convertStrToFormat('+'+ estimation?.promotion, 'money')}
                <span style={{ fontSize: '20px' }}> บาท</span>
              </span>
            </div>
            <div className="space-container">
              <span className="text-title-price">ราคาสุทธิ</span>
              <span className="text-detail-price">
                {convertStrToFormat(estimation?.finalPrice, 'money')}
                <span style={{ fontSize: '20px' }}> บาท</span>
              </span>
            </div>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <TextCustom
                text={'ด่วน! ทำนัดเข้าขายราคานี้ได้'}
                size={'24px'}
                color={'red'}
                align="center"
              />
            </div>
                <div style={{ display: 'flex', justifyContent: 'center' }}>
              <TextCustom
                text={'ภายใน 7 วันเท่านั้น*'}
                size={'24px'}
                color={'red'}
                align="center"
              />
            </div>
            <div style={{ display: 'flex', justifyContent: 'center', marginTop:'10px', textAlign: 'center' }}>
              <TextCustom
                text={' (*ราคาที่แจ้งเป็นราคาประเมินเบื้องต้น'}
                size={'16px'}
                align="center"
                color={'black'}
              />
            </div>
            <div style={{ display: 'flex', justifyContent: 'center', textAlign: 'center' }}>
              <TextCustom
                text={'โดยเครื่องจะต้องมีสภาพสมบูรณ์ตามประเมินไว้หากเครื่องไม่เป็นไปตามที่แจ้ง'}
                size={'16px'}
                color={'black'}
                align="center"
                
              />
            </div>

            <div style={{ display: 'flex', justifyContent: 'center', textAlign: 'center' }}>
              <TextCustom
                text={'จะต้องทำการประเมินใหม่ อ้างอิงราคาตามเรทที่ดีที่สุด ณ วันที่เข้าขายเท่านั้น) '}
                size={'16px'}
                color={'black'}
                align="center"
                
              />


            </div>
          </StyledContainerBlock>
        </Col>
        <Col {...BREAKE_POINT?.MAIN_CONTENT}>
          <StyledContainerBlock style={{ padding: '20px' }}>
            <TextTitle text={'รายละเอียดการนัดหมาย'} bold />
            {booking.map((el, i) => {
              return (
                <div className="space-container" key={`booking_detail_${i}`}>
                  <span className="text-title">{el.title}</span>
                  <span className="text-detail" style={{ color: el.color || '' }}>
                    {el.description}
                  </span>
                </div>
              );
            })}
          </StyledContainerBlock>
        </Col>
      </Row>
    </div>
  );
};
